import template from './tab-container.html'
import css from './tab-container.css'
import { TabContainerController } from './tab-container.controller.js'

export const TabContainerComponent = {
  template: template,
  controller: TabContainerController,
  controllerAs: 'TabContainerController',
  transclude: true
}



// WEBPACK FOOTER //
// ./src/client/common/uiComponents/TabContainer/tab-container.component.js